import {Avatar} from 'primereact/avatar'
import {Button} from 'primereact/button'
import {InputMask} from 'primereact/inputmask'
import {InputText} from 'primereact/inputtext'
import {InputTextarea} from 'primereact/inputtextarea'
import {useCallback, useRef, useState} from 'react'
import PhoneInput from 'react-phone-input-2'
import {useDebouncedCallback} from 'use-debounce'
import {ReactComponent as DuoRequiredInfo} from '../../assets/icons/DuoRequiredInfo.svg'
import {getLanguageCode} from '../../i18n/LanguageUtils'
import TranslateUtils from '../../i18n/TranslateUtils'
import AiWidget from '../../openAi/AiWidget'
import {useAIContext} from '../../openAi/OpenAiProvider'
import AddressForm from '../address/AddressForm'
import CodeConfig from '../client/CodeConfig'
import {component, formLayout} from '../form/Constant'
import GeneralPractitionerUtils from '../general-practioner/GeneralPractitionerUtils'
import ImageUploader from '../image/ImageUploader'
import {observationKeys} from '../observations/Constants'
import {isArrayAndNotEmpty, isBoolean} from '../observations/Utils'
import {parameterKeys} from '../parameter/ParameterConstants'
import {permissionOptionKeys} from '../role/RoleConstant'
import {convertKeyToLabel} from '../table-utils/TableUtils'
import CalendarUtils from './CalendarUtils'
import CheckboxUtils from './CheckboxUtils'
import ChipsUtils from './ChipsUtils'
import DropdownUtils from './DropdownUtils'
import MultiCheckboxUtils from './MultiCheckboxUtils'
import MultiSelectUtils from './MultiSelectUtils'
import SecurityDetailForm from './SecurityDetailForm'
import SelectButtonUtils from './SelectButtonUtils'
import SliderUtils from './SliderUtils'
const customLabelClassName =
    'font-bold p-0 text-sm sm:text-sm md:text-xl lg:text-xl'
const columnClassName = 'col-12'
const CustomForm = ({
    dataList = [],
    rightDataList = [],
    layout = formLayout.inline,
    labelSubmitButton = TranslateUtils().translateKeys('SUBMIT'),
    labelCancelButton = TranslateUtils().translateKeys('Cancel'),
    cancelButton = false,
    observation,
    information,
    userData,
    patient,
    isRoleData = false, // specifically used for role management form
    logList = {},
    hideSubmit = false,
    obsData = [],
    onCancel = () => {},
    onSubmit = () => {},
    onChangeCustomValue = () => {},
}) => {
    const formRefs = useRef([])
    const {translateKeys, translateOptions, translateCommons} = TranslateUtils()

    const handleSubmitOrGetData = useDebouncedCallback((isSubmit = true) => {
        let data = {}
        let holderList =
            dataList && Array.isArray(dataList) && dataList.length > 0
                ? [...dataList]
                : []

        if (!!isArrayAndNotEmpty(holderList)) {
            if (
                layout === formLayout.group ||
                layout === formLayout.flex ||
                layout === formLayout.grid
            ) {
                let tmp = []
                for (let i = 0; i < holderList.length; i++) {
                    if (
                        !!holderList[i]?.children &&
                        holderList[i].children.length > 0
                    ) {
                        tmp = tmp.concat(dataList[i].children)
                    }

                    if (
                        !!holderList[i]?.leftChildren &&
                        holderList[i].leftChildren.length > 0
                    ) {
                        tmp = tmp.concat(dataList[i].leftChildren)
                    }
                }

                holderList = [...tmp]
            }

            for (let i = 0; i < holderList.length; i++) {
                if (
                    holderList[i] &&
                    holderList[i].key &&
                    !!formRefs.current[holderList[i].key]
                ) {
                    if (holderList[i].component === component.phoneInput) {
                        data = {
                            ...data,
                            [holderList[i].key]:
                                formRefs.current[holderList[i].key].state
                                    .formattedNumber,
                            phoneExtension: {
                                dialCode:
                                    formRefs.current[holderList[i].key].state
                                        .selectedCountry.dialCode,
                                countryCode:
                                    formRefs.current[holderList[i].key].state
                                        .selectedCountry.countryCode,
                            },
                        }
                    } else if (
                        holderList[i].component === component.address ||
                        holderList[i].component === component.codeConfiguration
                    ) {
                        data = {
                            ...data,
                            ...formRefs.current[holderList[i].key].getValue(),
                        }
                    } else if (
                        holderList[i].component ===
                        component.generalPractitioner
                    ) {
                        data = {
                            ...data,
                            generalPractitioner:
                                formRefs.current[holderList[i].key].getValue(),
                        }
                    } else {
                        data = {
                            ...data,
                            [holderList[i].key]:
                                formRefs.current[holderList[i].key].value,
                        }
                    }
                }
            }
            if (onSubmit && !!isSubmit) {
                if (!!observation && !information) {
                    onSubmit({
                        ...data,
                        createdAtString: formRefs.current['createdAt'].value,
                    })

                    formRefs.current.value = []
                } else {
                    onSubmit({...data})
                    formRefs.current.value = []
                }
            }
        }

        return data
    }, 500)

    const handleOnSelectAllRole = useCallback(
        (key, value) => {
            if (!isBoolean(value) || key !== permissionOptionKeys.selectAll) {
                return
            }
            let holderList = !!isArrayAndNotEmpty(dataList) ? [...dataList] : []

            for (let i = 0; i < holderList.length; i++) {
                if (!!isArrayAndNotEmpty(holderList[i]?.children)) {
                    let childrenList = holderList[i]?.children
                    for (let j = 0; j < childrenList.length; j++) {
                        if (childrenList[j]?.component === component.checkbox) {
                            if (
                                childrenList[j]?.parentKey &&
                                childrenList[j]?.key
                            ) {
                                let refKey = `${
                                    childrenList[j]?.parentKey ?? ''
                                }-${childrenList[j]?.key ?? ''}`

                                formRefs.current[refKey]?.setValue(value)
                            }
                        }
                    }
                }
            }
        },
        [dataList],
    )

    const handleRoleSubmitData = useCallback(() => {
        let data = {
            name: '',
            description: '',
            permissions: [],
        }

        let holderList = !!isArrayAndNotEmpty(dataList) ? [...dataList] : []

        let permissionsTemp = []
        for (let i = 0; i < holderList.length; i++) {
            if (
                holderList[i] &&
                holderList[i].key &&
                holderList[i].key === permissionOptionKeys.basicInformation &&
                holderList[i]?.children.length > 0
            ) {
                for (let j = 0; j < holderList[i].children.length; j++) {
                    if (
                        holderList[i].children[j].key ===
                        permissionOptionKeys.name
                    ) {
                        data = {
                            ...data,
                            name: formRefs.current[permissionOptionKeys.name]
                                .value,
                        }
                    } else if (
                        holderList[i].children[j].key ===
                        permissionOptionKeys.description
                    ) {
                        data = {
                            ...data,
                            description:
                                formRefs.current[
                                    permissionOptionKeys.description
                                ].value,
                        }
                    }
                }
            } else if (
                holderList[i].key !== permissionOptionKeys.selectAllOrOnly
            ) {
                let item = {
                    roleCategory: holderList[i].key,
                }

                if (
                    holderList[i]?.key !==
                        permissionOptionKeys.selectAllOrOnly &&
                    !!isArrayAndNotEmpty(holderList[i]?.children)
                ) {
                    for (let j = 0; j < holderList[i].children.length; j++) {
                        if (
                            holderList[i].children[j].key !==
                            permissionOptionKeys.selectAll
                        ) {
                            item = {
                                ...item,
                                [holderList[i].children[j].key]:
                                    formRefs.current[
                                        `${holderList[i].children[j].parentKey}-${holderList[i].children[j].key}`
                                    ].value,
                            }
                        }
                    }
                }

                permissionsTemp.push(item)
            }
        }

        if (onSubmit) {
            onSubmit({...data, permissions: [...permissionsTemp]})
        }
    }, [dataList, onSubmit])

    const handleOnCancel = useCallback(() => {}, [])

    const handleOnImage = useCallback((key, imageUrls) => {
        formRefs.current[key].value = imageUrls
    }, [])

    const renderDescriptionItem = useCallback(() => {
        return (
            <div className="grid col-12 mb-5 p-0">
                <div className="col-12 mb-2">
                    <h4 className="mb-1 font-bold">
                        {translateKeys('Personal Information')}
                    </h4>
                    <hr className="highlighter" />
                </div>
                <div className="flex w-full">
                    {' '}
                    <div
                        className={`flex justify-content-center align-items-center p-4`}>
                        <Avatar
                            className={`mb-3 lg:mb-0 border-circle`}
                            style={{width: '120px', height: '120px'}}
                            image={
                                userData && userData.avatar
                                    ? userData.avatar
                                    : require('../../assets/images/avatar.jpg')
                            }
                            size="xlarge"
                            shape="circle"
                        />
                    </div>{' '}
                    <div
                        className={` flex flex-column gap-2 justify-content-center`}>
                        <h4 className="font-bold text-800 m-0 p-1">
                            {' '}
                            {userData?.fullName}
                        </h4>
                        <h6 className="font-semibold text-500 m-0 p-1">
                            {translateKeys('Age')}:{' '}
                            <span className="font-bold text-700 m-0 p-1">
                                {userData?.age}
                            </span>{' '}
                        </h6>
                        <h6 className="font-semibold text-500 m-0 p-1">
                            {translateKeys('Gender')} :{' '}
                            <span className="font-bold text-700">
                                {convertKeyToLabel(userData?.gender)}
                            </span>{' '}
                        </h6>
                        <h6 className="font-semibold text-500 m-0 p-1">
                            {translateKeys('Arrival Date')}:{' '}
                            <span className="font-bold text-700">
                                {userData?.createdAt}
                            </span>{' '}
                        </h6>{' '}
                    </div>
                </div>

                {!information && (
                    <div className="col-12 mb-2">
                        <h4 className="mb-1 font-bold">
                            {translateKeys('Date time')}
                        </h4>
                        <hr className="highlighter" />
                        <CalendarUtils
                            ref={el => (formRefs.current['createdAt'] = el)}
                            showTime
                            observation
                        />
                    </div>
                )}
            </div>
        )
    }, [translateKeys, userData, information])

    // eslint-disable-next-line no-unused-vars
    const [columnVisibility, setColumnVisibility] = useState(false)
    const handleOnToggleSelectVisibility = useCallback(
        (key, value) => {
            formRefs.current[key].value = value
            if (!observation) {
                return
            } else {
                let tasValue = {
                    [observationKeys.levelOfConsciousness]:
                        formRefs.current[observationKeys.levelOfConsciousness]
                            .value,
                    [observationKeys.heartRate]:
                        formRefs.current[observationKeys.heartRate].value,
                    [observationKeys.respiration]:
                        formRefs.current[observationKeys.respiration].value,
                    [observationKeys.oxygen]:
                        formRefs.current[observationKeys.oxygen].value,
                    [observationKeys.temperature]:
                        formRefs.current[observationKeys.temperature].value,
                    [observationKeys.systolic]:
                        formRefs.current[observationKeys.systolic].value,
                }
                onChangeCustomValue(tasValue)
                setColumnVisibility(prev => !prev)
            }
        },
        [onChangeCustomValue, observation],
    )

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getLabelItem = (key, value) => {
        if (!key) {
            return ''
        }
        let label = ''
        switch (key) {
            case observationKeys.confusion:
                if (
                    key ===
                    formRefs.current[observationKeys.levelOfConsciousness]
                        ?.value
                ) {
                    label = `${translateCommons('Is this new confusion')} ?`
                }
                break
            case observationKeys.litres:
                if (!!value) {
                    label = 'Litres (L)'
                }
                break
            case observationKeys.oxygen:
                label = translateKeys('Oxygen Saturation')
                break
            case parameterKeys.oxygenUpper:
                label = translateKeys('Oxygen Saturation Upper')
                break
            case parameterKeys.oxygenLower:
                label = translateKeys('Oxygen Saturation Lower')
                break
            default:
                label = translateKeys(convertKeyToLabel(key))
                break
        }
        return label
    }
    const {onSendAiRequest, handleOnFocus, focusKey} = useAIContext()

    // eslint-disable-next-line no-unused-vars
    const onSendMsgToAI = useCallback(
        msg => {
            onSendAiRequest(msg)
        },
        [onSendAiRequest],
    )

    const [callbackData, setCallbackData] = useState(false)
    const handleOnApply = useCallback(
        (key, value) => {
            setCallbackData(!callbackData)

            formRefs.current[key].value = value
        },
        [callbackData],
    )

    const renderItem = useCallback(
        itemList => {
            const isIncludedAnySupplementaryOxygenKeys = [
                'nasal',
                'simpleMask',
            ].includes(
                formRefs.current[observationKeys.anySupplementaryOxygen]?.value,
            )

            return itemList?.map((item, idx) => (
                <div
                    id={item.key}
                    className={`${item.className ? item.className : 'col-12'}`}
                    key={`item-${item.key}`}>
                    <div className="flex justify-content-between align-items-start">
                        {!item.hideHeader &&
                            item.component !== component.checkbox && (
                                <h5 className={`${customLabelClassName}`}>
                                    {translateKeys(
                                        item?.label ??
                                            getLabelItem(
                                                item.key,
                                                isIncludedAnySupplementaryOxygenKeys,
                                            ),
                                    )}

                                    {item.shorten && (
                                        <span>
                                            {' '}
                                            ( {translateKeys(item.shorten)} )
                                        </span>
                                    )}
                                </h5>
                            )}
                        {!!item?.required && (
                            <div>
                                <DuoRequiredInfo
                                    height={20}
                                    width={20}
                                    style={{color: 'red'}}
                                />
                                {/* <Tag
                                    value={translateCommons(
                                        'This field is required !',
                                    )}
                                    severity="danger"
                                    icon="pi pi-info-circle"></Tag> */}
                            </div>
                        )}
                    </div>

                    {/* RENDER COMPONENTS */}
                    {item.component === component.inputText ||
                    item.component === component.inputNumber ||
                    item.component === component.password ? (
                        <div>
                            <InputText
                                id={item.key}
                                className={`${columnClassName} h-3rem prevent-select`}
                                ref={el => (formRefs.current[item.key] = el)}
                                placeholder={translateKeys(item.placeholder)}
                                keyfilter={
                                    item.keyFilter ? /^[^<>*!/^|?,+= ]+$/ : ''
                                }
                                type={
                                    item.component === component.inputNumber
                                        ? 'number'
                                        : item.component === component.password
                                        ? 'password'
                                        : 'text'
                                }
                                defaultValue={
                                    item.initialValue
                                        ? item.initialValue
                                        : item.defaultValue
                                }
                            />
                        </div>
                    ) : item.component === component.inputTextArea ? (
                        <div className="relative">
                            <InputTextarea
                                id={item.key}
                                className={`${columnClassName} ${
                                    observation || information
                                        ? 'lightgray'
                                        : ''
                                } prevent-select`}
                                placeholder={translateKeys(item.placeholder)}
                                ref={el => (formRefs.current[item.key] = el)}
                                rows={5}
                                cols={30}
                                onFocus={() => handleOnFocus(item.key)}
                                defaultValue={
                                    item.initialValue
                                        ? item.initialValue
                                        : item.defaultValue
                                }
                                autoResize
                            />
                            {!!item?.isUseAI && focusKey === item.key && (
                                <AiWidget
                                    obsData={obsData || []}
                                    isObsForm={item?.isObsForm || false}
                                    formData={handleSubmitOrGetData(false)}
                                    value={
                                        formRefs.current[item.key]?.value ?? ''
                                    }
                                    onApply={value => {
                                        handleOnApply(item.key, value)
                                    }}
                                />
                            )}
                        </div>
                    ) : item.component === component.chip ? (
                        <ChipsUtils
                            id={item.key}
                            className={`col-12 ${columnClassName} ${
                                observation || information ? 'lightgray' : ''
                            } `}
                            placeholder={translateKeys(item.placeholder)}
                            ref={el => (formRefs.current[item.key] = el)}
                            rows={3}
                            cols={30}
                            defaultValue={
                                item.initialValue
                                    ? item.initialValue
                                    : item.defaultValue
                            }
                        />
                    ) : item.component === component.inputMask ? (
                        <InputMask
                            id={item.key}
                            className={`${columnClassName} h-3rem prevent-select`}
                            ref={el => (formRefs.current[item.key] = el)}
                            mask="99-99-9999"
                            placeholder={translateKeys(item.placeholder)}
                            slotChar="DD-MM-YYYY"
                            defaultValue={
                                item?.initialValue
                                    ? item.initialValue
                                    : item?.defaultValue
                                    ? item.defaultValue
                                    : ''
                            }
                        />
                    ) : item.component === component.checkbox ? (
                        <CheckboxUtils
                            className="mr-2"
                            id={item.key}
                            parentKey={!!item.parentKey ? item.parentKey : ''}
                            placeholder={translateKeys(item.placeholder)}
                            layout={item.layout}
                            ref={el =>
                                (formRefs.current[
                                    !!item.parentKey
                                        ? `${item.parentKey}-${item.key}`
                                        : item.key
                                ] = el)
                            }
                            defaultValue={
                                item.initialValue
                                    ? item.initialValue
                                    : item.defaultValue
                            }
                        />
                    ) : item.component === component.multiCheckbox ? (
                        <MultiCheckboxUtils
                            id={item.key}
                            checkboxList={translateOptions(item.options)}
                            placeholder={translateKeys(item.placeholder)}
                            layout={item.layout}
                            ref={el => (formRefs.current[item.key] = el)}
                        />
                    ) : item.component === component.dropdown ? (
                        <DropdownUtils
                            id={item.key}
                            required={!!item?.required}
                            className={`${columnClassName} p-0 m-0 prevent-select`}
                            optionsList={translateOptions(item.options)}
                            placeholder={translateKeys(item.placeholder)}
                            ref={el => (formRefs.current[item.key] = el)}
                            callBack={
                                !!item?.callBack ? item.callBack : () => {}
                            }
                            onSelectedAll={(key, value) =>
                                handleOnSelectAllRole(key, value)
                            }
                            defaultValue={
                                item.initialValue
                                    ? item.initialValue
                                    : item.defaultValue
                            }
                        />
                    ) : item.component === component.multiSelect ? (
                        <MultiSelectUtils
                            id={item.key}
                            className={`${columnClassName} p-0 m-0 prevent-select`}
                            options={translateOptions(item.options)}
                            placeholder={translateKeys(item.placeholder)}
                            ref={el => (formRefs.current[item.key] = el)}
                            defaultValue={
                                item.initialValue
                                    ? item.initialValue
                                    : item.defaultValue
                            }
                            required={!!item?.required}
                        />
                    ) : (item.component === component.selectButton &&
                          item.key !== observationKeys.confusion) ||
                      item.key ===
                          formRefs.current[observationKeys.levelOfConsciousness]
                              ?.value ? (
                        <SelectButtonUtils
                            id={item.key}
                            className={`${columnClassName}`}
                            patient={patient}
                            optionsList={translateOptions(item.options)}
                            placeholder={translateKeys(item.placeholder)}
                            onChangeKey={item.key}
                            multiple={item.multiple}
                            icon={item.icon}
                            ref={el => (formRefs.current[item.key] = el)}
                            defaultValue={
                                item.initialValue
                                    ? item.initialValue
                                    : item.defaultValue
                            }
                            onChangeValue={handleOnToggleSelectVisibility}
                        />
                    ) : item.component === component.calendar ? (
                        <div className="col-12 p-0">
                            <CalendarUtils
                                locale={
                                    getLanguageCode() === 'gb'
                                        ? 'en'
                                        : getLanguageCode()
                                }
                                id={item.key}
                                label={item.label}
                                className={`${columnClassName}`}
                                placeholder={translateKeys(item.placeholder)}
                                ref={el => (formRefs.current[item.key] = el)}
                                showTime={!!item?.showTime}
                                disabled={item.disabled}
                                classNameCalendar={item.classNameCalendar}
                                hideOnDateTimeSelect={true}
                                defaultValue={
                                    item.initialValue
                                        ? item.initialValue
                                        : item.defaultValue
                                }
                            />
                        </div>
                    ) : (item.component === component.slider &&
                          item.key !== observationKeys.litres) ||
                      (item.component === component.slider &&
                          !!isIncludedAnySupplementaryOxygenKeys) ? (
                        <SliderUtils
                            id={item.key}
                            min={item.min}
                            max={item.max}
                            step={item.step}
                            onChangeKey={item.key}
                            dataRange={item.dataRange}
                            colors={item.colors}
                            labelValue={item.labelValue}
                            observation
                            defaultValue={
                                item.initialValue
                                    ? item.initialValue
                                    : item.defaultValue
                            }
                            placeholder={translateKeys(item.placeholder)}
                            onChangeValue={handleOnToggleSelectVisibility}
                            ref={el => (formRefs.current[item.key] = el)}
                        />
                    ) : item.component === component.phoneInput ? (
                        <PhoneInput
                            id={item.key}
                            className={`${columnClassName}`}
                            placeholder={translateKeys(item.placeholder)}
                            ref={el => (formRefs.current[item.key] = el)}
                        />
                    ) : item.component === component.fileUpload ? (
                        <ImageUploader
                            id={item.key}
                            className={`${columnClassName}`}
                            initialImage={item.initialValue}
                            ref={el => (formRefs.current[item.key] = el)}
                            callBack={handleOnImage}
                            multiple={!!item?.multiple}
                            extraData={!!item?.extraData}
                        />
                    ) : item.component === component.address ? (
                        <AddressForm
                            id={item.key}
                            ref={el => (formRefs.current[item.key] = el)}
                            className={item.className ? item.className : ''}
                            childrenClassName={
                                item.childrenClassName
                                    ? item.childrenClassName
                                    : ''
                            }
                            defaultValue={
                                item.initialValue
                                    ? item.initialValue
                                    : item.defaultValue
                            }
                        />
                    ) : item.component === component.security ? (
                        <SecurityDetailForm
                            id={item.key}
                            ref={el => (formRefs.current[item.key] = el)}
                            className={item.className ? item.className : ''}
                            childrenClassName={
                                item.childrenClassName
                                    ? item.childrenClassName
                                    : ''
                            }
                            defaultValue={
                                item.initialValue
                                    ? item.initialValue
                                    : item.defaultValue
                            }
                        />
                    ) : item.component === component.generalPractitioner ? (
                        <GeneralPractitionerUtils
                            id={item.key}
                            ref={el => (formRefs.current[item.key] = el)}
                            className={item.className ? item.className : ''}
                            childrenClassName={
                                item.childrenClassName
                                    ? item.childrenClassName
                                    : ''
                            }
                            defaultValue={
                                item.initialValue
                                    ? item.initialValue
                                    : item.defaultValue
                            }
                        />
                    ) : item.component === component.codeConfiguration ? (
                        <CodeConfig
                            id={item.key}
                            ref={el => (formRefs.current[item.key] = el)}
                            defaultValue={
                                item.initialValue
                                    ? item.initialValue
                                    : item.defaultValue
                            }
                        />
                    ) : null}

                    {!!item?.additionalInfo && (
                        <p className="text-md text-600 mt-3">
                            {item.additionalInfo}
                        </p>
                    )}

                    {item?.emptyMessage && (
                        <div className="col-12 px-0" style={{color: 'red'}}>
                            {item.emptyMessage}
                        </div>
                    )}
                </div>
            ))
        },
        [
            focusKey,
            getLabelItem,
            handleOnApply,
            handleOnFocus,
            handleOnImage,
            handleOnSelectAllRole,
            handleOnToggleSelectVisibility,
            handleSubmitOrGetData,
            information,
            obsData,
            observation,
            patient,
            translateCommons,
            translateKeys,
            translateOptions,
        ],
    )
    const renderFlexItem = useCallback(
        dataList => {
            return dataList?.map(item => (
                <div
                    key={`flex-${item.key}`}
                    className="flex flex-column col-12"
                    style={{borderBottom: '1px dashed lightgray'}}>
                    <div className="col-12" style={{position: 'relative'}}>
                        <div className="sticky">
                            <div className="mb-2">
                                <h4 className="mb-1 font-bold">
                                    {translateKeys(convertKeyToLabel(item.key))}
                                </h4>
                            </div>
                            {item?.description &&
                            typeof item?.description === 'string' ? (
                                <p>{item.description}</p>
                            ) : (
                                <div>{item.description}</div>
                            )}

                            {!!item?.note && (
                                <p className="text-md  text-600">{`${translateKeys(
                                    'Note',
                                )}: ${translateKeys(item?.note)}`}</p>
                            )}
                            {!!item?.required && (
                                <p className="text-md  text-600">
                                    *{' '}
                                    {translateKeys(
                                        'Required fields cannot be empty',
                                    )}
                                </p>
                            )}
                        </div>
                    </div>
                    {item.children && (
                        <div className="grid col-12">
                            {renderItem(item.children)}
                        </div>
                    )}
                </div>
            ))
        },
        [renderItem, translateKeys],
    )
    const renderGroupItem = useCallback(
        dataList => {
            return dataList?.map(item => {
                const parentLabel = item.label
                    ? translateKeys(item.label)
                    : translateKeys(convertKeyToLabel(item.key))

                return (
                    <div
                        key={`group-${item.key}`}
                        className={'grid relative col-12 p-0 mb-5'}
                        style={{borderBottom: '1px dashed lightgray'}}>
                        <div className="custom-form md:col-4 col-12 p-0">
                            <div
                                className="sticky"
                                style={!parentLabel ? {top: 0} : {}}>
                                {!!parentLabel && (
                                    <div className="mb-2">
                                        <h4 className="mb-1 font-bold">
                                            {translateKeys(parentLabel)}
                                        </h4>
                                        <hr className="highlighter" />
                                    </div>
                                )}
                                {!!observation
                                    ? renderDescriptionItem()
                                    : !!information && renderDescriptionItem()}
                                <div className="flex flex-column gap-1">
                                    {item?.description && (
                                        <p className="m-0 p-0 text-md font-semibold text-600">
                                            {translateKeys(item.description)}
                                        </p>
                                    )}
                                    {!!item?.note && (
                                        <p className="text-md  text-600">{`${translateKeys(
                                            'Note',
                                        )}: ${translateKeys(item?.note)}`}</p>
                                    )}
                                    {!!item?.required && (
                                        <p className="text-md  text-600">
                                            *{' '}
                                            {translateKeys(
                                                'Required fields cannot be empty',
                                            )}
                                        </p>
                                    )}
                                </div>

                                {item.leftChildren &&
                                    renderItem(item.leftChildren)}
                            </div>
                        </div>
                        {item.children && (
                            <div
                                className={
                                    item.layout === formLayout.grid
                                        ? 'col-12 grid p-0'
                                        : 'lg:col-8 md:col-8 col-12 grid p-0'
                                }>
                                {renderItem(item.children)}
                            </div>
                        )}
                    </div>
                )
            })
        },
        [
            translateKeys,
            observation,
            renderDescriptionItem,
            information,
            renderItem,
        ],
    )

    return layout === formLayout.inline ? (
        <div className="grid">
            <div
                className={`${
                    rightDataList && rightDataList.length > 0
                        ? 'md:col-5 col-12'
                        : 'col-12'
                } grid`}>
                {renderItem(dataList)}
            </div>

            {rightDataList && rightDataList.length > 0 && (
                <div className={`md:col-7 col-12`}>
                    <div className="grid">
                        {rightDataList &&
                            rightDataList.length > 0 &&
                            renderItem(rightDataList)}
                    </div>
                </div>
            )}

            <div className="col-12 py-3">
                <Button
                    visible={!hideSubmit}
                    className="col-12 p-button-lg font-bold  bg-teal-500"
                    label={labelSubmitButton}
                    icon={'pi pi-send'}
                    onClick={() => {
                        !!isRoleData
                            ? handleRoleSubmitData()
                            : handleSubmitOrGetData()
                    }}
                />
            </div>
        </div>
    ) : layout === formLayout.group ? (
        <div className="grid">
            {renderGroupItem(dataList)}
            <div className="flex col-12 py-3">
                <Button
                    visible={!hideSubmit}
                    className={`${
                        cancelButton ? 'col-6' : 'col-12'
                    } p-button-lg font-bold mr-2 bg-teal-600 border-0`}
                    icon={'pi pi-send'}
                    label={labelSubmitButton}
                    onClick={() => {
                        !!isRoleData
                            ? handleRoleSubmitData()
                            : handleSubmitOrGetData()
                    }}
                />
                {cancelButton && (
                    <Button
                        className="col-6 p-button-lg font-bold"
                        icon={'pi pi-send'}
                        label={labelCancelButton}
                        onClick={handleOnCancel}
                    />
                )}
            </div>
        </div>
    ) : (
        <div className="grid">
            {renderFlexItem(dataList)}
            <div className="flex col-12 py-3">
                <Button
                    visible={!hideSubmit}
                    className={`${
                        cancelButton ? 'col-6' : 'col-12'
                    } p-button-lg font-bold mr-2`}
                    icon={'pi pi-send'}
                    label={labelSubmitButton}
                    onClick={() => {
                        !!isRoleData
                            ? handleRoleSubmitData()
                            : handleSubmitOrGetData()
                    }}
                />
                {cancelButton && (
                    <Button
                        className="col-6 p-button-lg font-bold"
                        icon={'pi pi-send'}
                        label={labelCancelButton}
                        onClick={handleOnCancel}
                    />
                )}
            </div>
        </div>
    )
}

export default CustomForm
